/* ⚠️ GENERATED from app/services/profilePrivacy.ts by gen-twins.mjs — edit the TypeScript, not this. */
// services/profilePrivacy.ts — public or private, decided in one place.
//
// 🟥 THE BROWSER HAD NO IDEA THIS SETTING EXISTED. The phone has always
//    written `users/{uid}.isPrivate` and drawn a lock or a globe on your own
//    picture; the web profile showed neither the badge nor any way to change
//    it, so the same account looked unlocked in one client and locked in the
//    other. Nothing needed migrating — the field was already there and already
//    correct. What was missing was a second reader.
//
// 🟢 THE FIELD IS THE CONTRACT. Both clients read and write the same boolean on
//    the same document, so a change on either is live on the other through the
//    listener each already has open. There is no sync step and nothing to keep
//    in step — that is the point of not inventing a second field.

/**
 * 🟥 ABSENT MEANS PUBLIC, and that is load-bearing rather than a default. Every
 *    account created before the setting existed has no field at all, and
 *    treating a missing value as private would have silently locked all of
 *    them.
 */
export function isPrivateProfile(doc) {
  return !!doc?.isPrivate;
}

/** The setting as the two words the UI offers. */
export function privacyOf(doc) {
  return isPrivateProfile(doc) ? 'private' : 'everyone';
}

/** What the chosen word writes back. */
export function privacyValue(p) {
  return p === 'private';
}
/**
 * The badge on your own profile picture.
 *
 * 🟢 THE COLOURS ARE THE PHONE'S, to the digit. A red padlock and a blue globe
 *    is what the app has drawn for as long as the setting has existed, and a
 *    browser that chose its own two colours would make the same account look
 *    like two accounts.
 */
export function privacyBadge(isPrivate) {
  return isPrivate ? {
    icon: 'lock',
    color: '#FF6B6B',
    label: 'Private'
  } : {
    icon: 'globe',
    color: '#4285F4',
    label: 'Everyone'
  };
}

/**
 * Is this profile's grid withheld from this viewer?
 *
 * 🟥 THE OWNER IS NEVER LOCKED OUT OF THEIR OWN PROFILE, which sounds obvious
 *    and is exactly the case a "private means hidden" one-liner gets wrong.
 */
export function isLockedFor(doc, viewerUid, ownerUid, friendship) {
  if (!isPrivateProfile(doc)) return false;
  if (viewerUid && ownerUid && viewerUid === ownerUid) return false;
  return friendship !== 'accepted';
}
